<template>
  <div class="text-left">
    <mdb-breadcrumb class="breadcrumb-with-arrows">
      <mdb-breadcrumb-item v-for="(bc,i) in breadcrumbs" :key="i">
        <span v-if="breadcrumbs.length == i+1">{{ bc.name }}</span>
        <a v-if="i+1 < breadcrumbs.length" href="" @click.prevent="loadFolders(bc)">{{ bc.name }}</a>
      </mdb-breadcrumb-item>
    </mdb-breadcrumb>
    <div v-if="foldersOnly && allowRoot && breadcrumbs.length == 1">
      <mdb-btn v-if="foldersOnly" size="sm" icon="check" @click="$emit('selectedFolder', null)">{{selectLabel}} Folder</mdb-btn>
    </div>

    <div v-if="foldersOnly && breadcrumbs.length > 1">
      <mdb-btn v-if="foldersOnly" size="sm" icon="check" @click="$emit('selectedFolder', currentFolder)">{{selectLabel}} {{currentFolder.name}}</mdb-btn>
    </div>

    <div v-for="folder in folders" v-bind:key="folder.id" >
      <a role="button" @click="loadFolders(folder)" v-if="!excludeFolder || excludeFolder.id != folder.id">
        <mdb-icon far icon="folder" size="2x"/>
        {{ folder.name }}
      </a>
    </div>
    <div v-if="currentFolder && !foldersOnly">
      <mdb-btn icon="arrow-left" size="sm" @click="currentFolder=null">Back to Folder List</mdb-btn>
    </div>

  </div>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBadge,
  mdbBreadcrumb,
  mdbBreadcrumbItem,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTooltip,
  mdbTreeview,
  mdbTreeviewItem,
  mdbView,
} from 'mdbvue';

export default {
  name: "file-folder-navigator",
  display: "Image Folder Navigator",
  order: 1,
  components: {
    mdbContainer,
    mdbBreadcrumb,
    mdbBreadcrumbItem,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbListGroup,
    mdbListGroupItem,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardImage,
    mdbMask,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbIcon,
    mdbTreeview,
    mdbTreeviewItem,
    mdbBadge,
    mdbView,
    mdbTooltip,
    mdbInput,
  },
  mounted() {
    this.loadFolders( null )
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    foldersOnly: {
      type: Boolean,
      default: false
    },
    excludeFolder: {
      type: Object,
      default: null
    },
    allowRoot: {
      type: Boolean,
      default: false
    },
    selectLabel: {
      type: String,
      default: "Select"
    }
  },
  data() {
    return {
      folders: [],
      breadcrumbs: [{id: 0, name: "Top"}],
      currentFolder: null,
      files: []
    }
  },
  methods: {
    loadFolders(folder) {
      this.$store.dispatch("setExecuting", true)
      let url = "/groupFile/list/" + this.group.vanityPath
      if (folder) {
        url += "/?folder=" + folder.id
        if (this.foldersOnly) url += "&fo=1"
      }
      else {
        if (this.foldersOnly) url += "?fo=1"
      }
      api.get(url).then(
        (results) => {
          this.folders = results.data.folders
          this.images = results.data.files
          this.breadcrumbs = results.data.breadcrumbs
          this.currentFolder = this.breadcrumbs[this.breadcrumbs.length -1]
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }
};
</script>


